module.exports = __webpack_public_path__ + "media/images/icons/flags/KI-dd782553fe62201c27b51722931510f4.svg";